import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentFeatureMediaFragmentFragmentDoc } from '../../../../services/yi/queries/ContentFeatureMediaFragment.generated'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
import { YiCourseModuleDownload_ContentFragmentFragmentDoc } from './YICourseModuleDownloadContentFragment.generated'
import { Content_ProviderMetadataFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderMetadataFragment.generated'
export type YiCourseModule_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  title?: string | null
  contentType?: string | null
  contentId?: number | null
  description?: string | null
  descriptionFormat?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  primaryLanguage?: string | null
  language?: string | null
  shortDescription?: string | null
  shortDescriptionFormat?: string | null
  path?: string | null
  contentPolicyPolicyId?: number | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiCourseModuleType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiConsumptionType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiYogaStyles?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  yiCourseModuleDownload?: Array<{
    __typename?: 'ContentAssetReference'
    id?: string | null
    asset?: {
      __typename?: 'Asset'
      id?: string | null
      mimeType?: string | null
      fileSize?: number | null
      originalFileName?: string | null
      renderUrl?: string | null
      contentAssetReference?: {
        __typename?: 'ContentAssetReference'
        assetsId?: string | null
      } | null
    } | null
  } | null> | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export const YiCourseModule_ContentFragmentFragmentDoc = gql`
  fragment YICourseModule_ContentFragment on Content {
    id
    title
    contentType
    contentId
    description
    descriptionFormat
    published
    publishedAtDate
    primaryLanguage
    language
    shortDescription
    shortDescriptionFormat
    path
    ...ContentFeatureMediaFragment
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiCourseModuleType: contentReferencesFrom(types: "yi-course-module-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiConsumptionType: contentReferencesFrom(types: "yi-consumption-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiYogaStyles: contentReferencesFrom(types: "yi-yoga-style") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    ...YICourseModuleDownload_ContentFragment
    ...Content_ProviderMetadataFragment
  }
  ${ContentFeatureMediaFragmentFragmentDoc}
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${YiCourseModuleDownload_ContentFragmentFragmentDoc}
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
